import React from 'react'
import cashbackBanner from '@loyal_images/banners/landing-cashback/cahsback-banner.png'

const Spotlight = props => {
  return (
    <div className='spotlight'>
      <div className='container bx-banner'>
        <div className='spotlight-info'>
          <h1>Quer Cashback?</h1>
          <p aria-hidden='true'>
            Compre no shopping iupp, ganhe pontos e use eles para ganhar até <strong>6% de cashback
              em cŕedito</strong> na fatura do seu cartão Itaú.
          </p>
          <div className='hide-absolute'>
            Compre no shopping iupp, ganhe pontos e use eles para ganhar até 6% de cashback em cŕedito na fatura do seu cartão Itaú.
          </div>
        </div>
        <div className='spotlight-image'>
          <img src={cashbackBanner} alt='cashback banner' />
        </div>
      </div>
    </div>
  )
}

export default Spotlight



// WEBPACK FOOTER //
// ./src/features/LandingPage/LandingCashbackBlack/Spotlight/Spotlight.js